import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
  rootContainer: {
    padding: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(1),
    },
  },
  navigationContainer: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    paddingTop: theme.spacing(3),
  },
  tabsContainer: {
    borderBottomColor: theme.palette.input.border,
    borderBottomStyle: 'solid',
    borderBottomWidth: 1,
  },
  mainContainer: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  selectPropertyContainer: {
    padding: theme.spacing(2, 4, 0, 4),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(2),
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(4),
    gap: theme.spacing(2),
    width: '100%',
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(2),
    },
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2),
    [theme.breakpoints.down('lg')]: {
      flexDirection: 'column',
      gap: theme.spacing(3),
    },
  },
  dividerVertical: {
    backgroundColor: theme.palette.text.hint,
    height: 'auto',
    [theme.breakpoints.down('lg')]: {
      width: '100%',
      height: 1,
    },
  },
  formColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(5),
    flex: 1,
    minWidth: 0,
    [theme.breakpoints.down('md')]: {
      gap: theme.spacing(3),
    },
  },
  navigation: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    '& > .MuiTabs-root': {
      flex: 1,
      minWidth: 0,
    },
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      gap: theme.spacing(1),
      '& > .MuiTabs-root': {
        width: '100%',
      },
    },
  },
  subTitle: {
    color: theme.palette.tab.offselected,
    fontWeight: 500,
    marginBottom: theme.spacing(1)
  },
}));
